import { t } from '@lingui/macro';
import * as ChartAnnotation from 'chartjs-plugin-annotation';
import React, { memo } from 'react';
import Avatar from '../../../component/Avatar';
import CustomChart from '../components/CustomChart/CustomChart';
import { createCanvas } from '../utils';

const getOption = () => ({
  plugins: [ChartAnnotation],
  aspectRatio: 1,
  tooltips: {
    enabled: false,
    position: 'nearest',
    mode: 'nearest',
    backgroundColor: '#f5f5f5',
    titleFontColor: '#333',
    bodyFontColor: '#666',
    bodySpacing: 4,
    xPadding: 12,
    intersect: 0,
  },
  annotation: {
    drawTime: 'beforeDatasetsDraw',
    annotations: [
      {
        type: 'line',
        mode: 'horizontal',
        scaleID: 'y-axis-0',
        value: 0,
        borderColor: '#eeeeee',
        borderWidth: 2,
        borderDash: [3, 3],
      },
    ],
  },
  legend: {
    display: false,
  },
  elements: {
    point: {
      pointStyle: (context) => {
        if (!context) return;
        const { avatar, r } = context?.dataset?.data?.[context.dataIndex] || {};
        return avatar ? createCanvas(r + 5, avatar) : 'circle';
      },
    },
  },
  scales: {
    xAxes: [
      {
        scaleLabel: {
          labelString: t`Khách hàng`,
        },
        ticks: {
          suggestedMin: 0,
          beginAtZero: true,
          callback: function (value) {
            if (value % 1 === 0) {
              return value;
            }
          },
        },
      },
    ],
    yAxes: [
      {
        scaleLabel: {
          labelString: t`Tốc độ phản hồi`,
        },
        ticks: {
          suggestedMin: 0,
        },
      },
    ],
  },
});

const getColumns = () => [
  {
    Header: '',
    accessor: 'avatar',
    className: 'flex-center-row',
    width: 80,
    Cell: ({ value }) => {
      return <Avatar user={{ avatar: value }} size={30} margin={false} />;
    },
  },
  {
    Header: '',
    accessor: 'name',
  },
  {
    Header: t`Tốc độ (phút)`,
    width: 100,
    accessor: 'y',
  },
  {
    Header: t`Khách hàng`,
    width: 100,
    accessor: 'x',
  },
  {
    Header: t`Rate`,
    width: 100,
    accessor: 'rate',
    Cell: ({ value }) => {
      return value ? <div>{value}/3</div> : '';
    },
  },
  {
    Header: t`Lượt rate`,
    width: 100,
    accessor: 'total_rate',
  },
];

const StaffResponsePerformance = (props) => {
  return <CustomChart getOption={getOption} columns={getColumns()} {...props} />;
};

export default memo(StaffResponsePerformance);
